import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var createclbookSlice = createSlice({
    name: "createclbook",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _createclbookSlice_actions = createclbookSlice.actions;
export var fetchData = _createclbookSlice_actions.fetchData, fetchDataSuccess = _createclbookSlice_actions.fetchDataSuccess, fetchDataFailure = _createclbookSlice_actions.fetchDataFailure, resetState = _createclbookSlice_actions.resetState;
export default createclbookSlice.reducer;
